// Custom Calendar Icon
export const CalendarIcon = () => (
  <svg
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8333 1V4.33333M5.16667 1V4.33333M1 7.66667H16M2.66667 2.66667H14.3333C15.2538 2.66667 16 3.41286 16 4.33333V16C16 16.9205 15.2538 17.6667 14.3333 17.6667H2.66667C1.74619 17.6667 1 16.9205 1 16V4.33333C1 3.41286 1.74619 2.66667 2.66667 2.66667Z"
      stroke="#8C8C8C"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Custom Download Icon
export const CustomDownloadIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5M5.83333 8.33333L10 12.5M10 12.5L14.1667 8.33333M10 12.5V2.5"
      stroke="#8C8C8C"
      strokeWidth="1.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Custom Refresh Icon
export const CustomRefreshIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.1663 3.33527V8.33527M19.1663 8.33527H14.1663M19.1663 8.33527L15.2997 4.70193C14.4041 3.80586 13.296 3.15127 12.079 2.79925C10.862 2.44722 9.5756 2.40923 8.33991 2.68882C7.10423 2.96841 5.95951 3.55646 5.01256 4.39812C4.06562 5.23977 3.34731 6.30759 2.92467 7.50193M0.833008 16.6686V11.6686M0.833008 11.6686H5.83301M0.833008 11.6686L4.69967 15.3019C5.5953 16.198 6.70332 16.8526 7.92035 17.2046C9.13738 17.5567 10.4238 17.5946 11.6594 17.3151C12.8951 17.0355 14.0398 16.4474 14.9868 15.6058C15.9337 14.7641 16.652 13.6963 17.0747 12.5019"
      stroke="#8C8C8C"
      strokeWidth="1.04167"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Tab Icons
export const UsersIcon = ({ color = '#007bff' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3327 14V12.6667C11.3327 11.9594 11.0517 11.2811 10.5516 10.781C10.0515 10.281 9.37319 10 8.66602 10H3.33268C2.62551 10 1.94716 10.281 1.44706 10.781C0.946967 11.2811 0.666016 11.9594 0.666016 12.6667V14M14.666 14V12.6667C14.6656 12.0758 14.4691 11.5019 14.1068 11.0349C13.7444 10.5679 13.2361 10.2344 12.666 10.0867M10.3327 2.08667C10.904 2.23354 11.4136 2.56714 11.7768 3.03488C12.1401 3.50262 12.3368 4.07789 12.3368 4.67C12.3368 5.26211 12.1401 5.83738 11.7768 6.30512C11.4136 6.77286 10.904 7.10646 10.3327 7.25333M8.66602 4.66667C8.66602 6.13943 7.47211 7.33333 5.99935 7.33333C4.52659 7.33333 3.33268 6.13943 3.33268 4.66667C3.33268 3.19391 4.52659 2 5.99935 2C7.47211 2 8.66602 3.19391 8.66602 4.66667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ActivityIcon = ({ color = '#4d4d4d' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 8H11.3333L9.33333 14L6.66667 2L4.66667 8H1.33333"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FolderIcon = ({ color = '#4d4d4d' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6667 12.6667C14.6667 13.0203 14.5262 13.3594 14.2761 13.6095C14.0261 13.8595 13.687 14 13.3333 14H2.66667C2.31304 14 1.97391 13.8595 1.72386 13.6095C1.47381 13.3594 1.33333 13.0203 1.33333 12.6667V3.33333C1.33333 2.97971 1.47381 2.64057 1.72386 2.39052C1.97391 2.14048 2.31304 2 2.66667 2H6L7.33333 4H13.3333C13.687 4 14.0261 4.14048 14.2761 4.39052C14.5262 4.64057 14.6667 4.97971 14.6667 5.33333V12.6667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsIcon = ({ color = '#4d4d4d' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.9333 9.99999C12.8444 10.2025 12.8187 10.4266 12.8595 10.6442C12.9003 10.8618 13.0058 11.0624 13.1627 11.22L13.2067 11.264C13.3307 11.3878 13.4293 11.5351 13.4969 11.6972C13.5645 11.8593 13.5997 12.0331 13.5997 12.2087C13.5997 12.3842 13.5645 12.558 13.4969 12.7201C13.4293 12.8822 13.3307 13.0295 13.2067 13.1533C13.0829 13.2773 12.9355 13.3759 12.7735 13.4435C12.6114 13.5111 12.4376 13.5463 12.262 13.5463C12.0864 13.5463 11.9127 13.5111 11.7506 13.4435C11.5885 13.3759 11.4411 13.2773 11.3173 13.1533L11.2733 13.1093C11.1158 12.9524 10.9151 12.8469 10.6975 12.8061C10.4799 12.7653 10.2558 12.791 10.0533 12.88C9.85487 12.9651 9.68637 13.1078 9.56911 13.2899C9.45185 13.472 9.39087 13.6856 9.39334 13.9033V14C9.39334 14.3536 9.25286 14.6928 9.00281 14.9428C8.75277 15.1929 8.41363 15.3333 8.06001 15.3333C7.70639 15.3333 7.36725 15.1929 7.11721 14.9428C6.86715 14.6928 6.72668 14.3536 6.72668 14V13.94C6.72056 13.7162 6.65245 13.4988 6.52996 13.3137C6.40748 13.1287 6.23574 12.9836 6.03334 12.8953C5.83083 12.8063 5.60669 12.7806 5.3891 12.8214C5.17151 12.8622 4.97092 12.9678 4.81334 13.1247L4.76934 13.1687C4.64554 13.2927 4.49817 13.3913 4.33608 13.4589C4.17399 13.5264 4.00017 13.5617 3.82468 13.5617C3.64918 13.5617 3.47535 13.5264 3.31327 13.4589C3.15118 13.3913 3.00381 13.2927 2.88001 13.1687C2.75598 13.0449 2.65737 12.8975 2.58978 12.7354C2.5222 12.5733 2.48694 12.3995 2.48694 12.224C2.48694 12.0485 2.5222 11.8747 2.58978 11.7126C2.65737 11.5505 2.75598 11.4031 2.88001 11.2793L2.92401 11.2353C3.08092 11.0778 3.18643 10.8771 3.22723 10.6595C3.26803 10.4419 3.24235 10.2178 3.15334 10.0153C3.06822 9.81686 2.92559 9.64837 2.74351 9.53111C2.56143 9.41385 2.34779 9.35287 2.13001 9.35533H2.03334C1.67972 9.35533 1.34058 9.21486 1.09053 8.96481C0.840485 8.71476 0.700012 8.37563 0.700012 8.022C0.700012 7.66838 0.840485 7.32924 1.09053 7.07919C1.34058 6.82915 1.67972 6.68867 2.03334 6.68867H2.09334C2.31719 6.68255 2.53454 6.61444 2.71964 6.49196C2.90473 6.36947 3.04982 6.19774 3.13801 5.99533C3.22701 5.79282 3.2527 5.56868 3.2119 5.35109C3.1711 5.1335 3.06558 4.93291 2.90868 4.77533L2.86468 4.73133C2.74064 4.60753 2.64204 4.46016 2.57445 4.29808C2.50687 4.13599 2.47161 3.96216 2.47161 3.78667C2.47161 3.61117 2.50687 3.43735 2.57445 3.27526C2.64204 3.11318 2.74064 2.9658 2.86468 2.842C2.98847 2.71797 3.13585 2.61936 3.29793 2.55178C3.46001 2.48419 3.63384 2.44893 3.80934 2.44893C3.98483 2.44893 4.15866 2.48419 4.32074 2.55178C4.48283 2.61936 4.6302 2.71797 4.75401 2.842L4.79801 2.886C4.95559 3.0429 5.15618 3.14842 5.37377 3.18922C5.59136 3.23002 5.81549 3.20434 6.01801 3.11533H6.06001C6.25844 3.03021 6.42693 2.88758 6.54419 2.7055C6.66145 2.52342 6.72243 2.30978 6.71996 2.092V2C6.71996 1.64638 6.86044 1.30724 7.11048 1.05719C7.36053 0.807149 7.69967 0.666672 8.05329 0.666672C8.40691 0.666672 8.74604 0.807149 8.99609 1.05719C9.24614 1.30724 9.38661 1.64638 9.38661 2V2.06C9.38408 2.27778 9.44506 2.49142 9.56232 2.6735C9.67958 2.85558 9.84807 2.99821 10.0465 3.08333C10.249 3.17234 10.4731 3.19802 10.6907 3.15722C10.9083 3.11642 11.1089 3.0109 11.2665 2.854L11.3105 2.81C11.4343 2.68597 11.5817 2.58736 11.7437 2.51978C11.9058 2.45219 12.0797 2.41693 12.2552 2.41693C12.4307 2.41693 12.6045 2.45219 12.7666 2.51978C12.9286 2.58736 13.076 2.68597 13.1998 2.81C13.3239 2.93379 13.4225 3.08117 13.4901 3.24325C13.5577 3.40533 13.5929 3.57916 13.5929 3.75466C13.5929 3.93016 13.5577 4.10399 13.4901 4.26607C13.4225 4.42815 13.3239 4.57553 13.1998 4.69933L13.1558 4.74333C12.9989 4.90091 12.8934 5.1015 12.8526 5.31909C12.8118 5.53668 12.8375 5.76082 12.9265 5.96333V6.00533C13.0116 6.20377 13.1542 6.37225 13.3363 6.48951C13.5184 6.60677 13.7321 6.66775 13.9498 6.66533H14.0465C14.4001 6.66533 14.7392 6.80581 14.9893 7.05586C15.2393 7.3059 15.3798 7.64504 15.3798 7.99866C15.3798 8.35228 15.2393 8.69142 14.9893 8.94147C14.7392 9.19151 14.4001 9.33199 14.0465 9.33199H13.9865C13.7687 9.32946 13.5551 9.39044 13.373 9.5077C13.1909 9.62496 13.0483 9.79345 12.9632 9.99188L12.9333 9.99999Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const GlobeIcon = ({ color = '#4d4d4d' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00001 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8.00001C14.6667 4.31811 11.6819 1.33334 8.00001 1.33334C4.31811 1.33334 1.33334 4.31811 1.33334 8.00001C1.33334 11.6819 4.31811 14.6667 8.00001 14.6667Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.33334 8H14.6667"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00001 1.33334C9.66689 3.15906 10.6134 5.53363 10.6667 8.00001C10.6134 10.4664 9.66689 12.841 8.00001 14.6667C6.33314 12.841 5.38663 10.4664 5.33334 8.00001C5.38663 5.53363 6.33314 3.15906 8.00001 1.33334Z"
      stroke={color}
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Metric Icons
export const MetricUsersIcon = ({ color = '#c144ff' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M22 21V19C21.9993 18.1137 21.7044 17.2528 21.1614 16.5523C20.6184 15.8519 19.8581 15.3516 19 15.13M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TrendingUpIcon = ({ color = '#128d16' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23 6L13.5 15.5L8.5 10.5L1 18M23 6H17M23 6V12"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const UserPlusIcon = ({ color = '#e28b27' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 21V19C16 17.9391 15.5786 16.9217 14.8284 16.1716C14.0783 15.4214 13.0609 15 12 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 11V17M20 14H26M12.5 7C12.5 9.20914 10.7091 11 8.5 11C6.29086 11 4.5 9.20914 4.5 7C4.5 4.79086 6.29086 3 8.5 3C10.7091 3 12.5 4.79086 12.5 7Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MaximizeIcon = ({ color = '#8C8C8C' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3H21M21 3V9M21 3L14 10M9 21H3M3 21V15M3 21L10 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowLeftIcon = ({ color = '#4d4d4d' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 18L9 12L15 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ArrowRightIcon = ({ color = '#4d4d4d' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 18L15 12L9 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FilterIcon = ({color = '#7A7A7A', width="24", height="24"}) => (
<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 17.6396L16 17.6397V17.6396H15ZM14.6582 18.1143L14.9743 19.063L14.9744 19.0629L14.6582 18.1143ZM9.6582 19.7803L9.34209 18.8316L9.34198 18.8316L9.6582 19.7803ZM9 19.3066H8L8 19.3073L9 19.3066ZM8.70711 11.7071L9.41421 11L8.70711 11.7071ZM15.2929 11.7071L14.5858 11L15.2929 11.7071ZM19.7071 7.29289L20.4142 8L19.7071 7.29289ZM19.7071 7.29289L19 6.58579L14.5858 11L15.2929 11.7071L16 12.4142L20.4142 8L19.7071 7.29289ZM15 12.4142H14V17.6396H15H16V12.4142H15ZM15 17.6396L14 17.6396C14 17.4254 14.1369 17.2339 14.342 17.1656L14.6582 18.1143L14.9744 19.0629C15.5878 18.8585 16 18.2843 16 17.6397L15 17.6396ZM14.6582 18.1143L14.3421 17.1655L9.34209 18.8316L9.6582 19.7803L9.97432 20.729L14.9743 19.063L14.6582 18.1143ZM9.6582 19.7803L9.34198 18.8316C9.66442 18.7241 9.99977 18.9636 10 19.306L9 19.3066L8 19.3073C8.00068 20.3319 9.00467 21.0522 9.97443 20.729L9.6582 19.7803ZM9 19.3066H10V12.4142H9H8V19.3066H9ZM8.70711 11.7071L9.41421 11L5 6.58579L4.29289 7.29289L3.58579 8L8 12.4142L8.70711 11.7071ZM4 6.58579H5V5H4H3V6.58579H4ZM5 4V5H19V4V3H5V4ZM20 5H19V6.58579H20H21V5H20ZM19 4V5H20H21C21 3.89543 20.1046 3 19 3V4ZM4 5H5V5V4V3C3.89543 3 3 3.89543 3 5H4ZM4.29289 7.29289L5 6.58579H5H4H3C3 7.11622 3.21071 7.62493 3.58579 8L4.29289 7.29289ZM9 12.4142H10C10 11.8838 9.78929 11.3751 9.41421 11L8.70711 11.7071L8 12.4142V12.4142H9ZM15.2929 11.7071L14.5858 11C14.2107 11.3751 14 11.8838 14 12.4142H15H16V12.4142L15.2929 11.7071ZM19.7071 7.29289L20.4142 8C20.7893 7.62493 21 7.11622 21 6.58579H20H19L19.7071 7.29289Z" fill={color}/>
</svg>)

export const EditPencilIcon = ({color = "#212121", width="24", height="24"}) => (
<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.1875 5.42383C15.6118 5.46926 15.9499 5.66401 16.2188 5.86914C16.503 6.08603 16.8078 6.39374 17.1211 6.70703L17.293 6.87891C17.6063 7.1922 17.914 7.49698 18.1309 7.78125C18.3653 8.08862 18.5859 8.48644 18.5859 9C18.5859 9.51356 18.3653 9.91138 18.1309 10.2188C17.914 10.503 17.6063 10.8078 17.293 11.1211L10.0986 18.3154C9.94157 18.4725 9.73819 18.6886 9.47461 18.8379C9.21089 18.9872 8.92063 19.0506 8.70508 19.1045L6.09668 19.7559L6.09473 19.7568L6.05078 19.7676C5.90293 19.8045 5.68156 19.8628 5.4873 19.8818C5.28061 19.9021 4.82874 19.9088 4.45996 19.54C4.09118 19.1713 4.09794 18.7194 4.11816 18.5127C4.13719 18.3184 4.19546 18.0971 4.23242 17.9492L4.89551 15.2949C4.9494 15.0794 5.0128 14.7891 5.16211 14.5254C5.31138 14.2618 5.5275 14.0584 5.68457 13.9014L12.8789 6.70703C13.1922 6.39374 13.497 6.08603 13.7812 5.86914C14.0886 5.63466 14.4864 5.41406 15 5.41406L15.1875 5.42383Z" stroke={color} stroke-width="2"/>
<path d="M12.5 7.5L15.5 5.5L18.5 8.5L16.5 11.5L12.5 7.5Z" fill={color}/>
</svg>
)

export const DeleteIcon = ({color = "#C90505", width="24", height="24"}) => (
<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 15L10 12" stroke={color} stroke-width="2" stroke-linecap="round"/>
<path d="M14 15L14 12" stroke={color} stroke-width="2" stroke-linecap="round"/>
<path d="M3 7H21C20.0681 7 19.6022 7 19.2346 7.15224C18.7446 7.35523 18.3552 7.74458 18.1522 8.23463C18 8.60218 18 9.06812 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V10C6 9.06812 6 8.60218 5.84776 8.23463C5.64477 7.74458 5.25542 7.35523 4.76537 7.15224C4.39782 7 3.93188 7 3 7Z" stroke={color} stroke-width="2" stroke-linecap="round"/>
<path d="M10.0681 3.37059C10.1821 3.26427 10.4332 3.17033 10.7825 3.10332C11.1318 3.03632 11.5597 3 12 3C12.4403 3 12.8682 3.03632 13.2175 3.10332C13.5668 3.17033 13.8179 3.26427 13.9319 3.37059" stroke={color} stroke-width="2" stroke-linecap="round"/>
</svg>

)

export const LineUpIcon = ({color = "#212121", width="24", height="24"}) => (
<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21 6L15.7071 11.2929C15.3166 11.6834 14.6834 11.6834 14.2929 11.2929L12.7071 9.70711C12.3166 9.31658 11.6834 9.31658 11.2929 9.70711L7 14" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 3V17.8C3 18.9201 3 19.4802 3.21799 19.908C3.40973 20.2843 3.71569 20.5903 4.09202 20.782C4.51984 21 5.07989 21 6.2 21H21" stroke={color} stroke-width="2" stroke-linecap="round"/>
</svg>
)

export const PlayIcon = ({color = "#212121", width="37", height="39"}) => (
<svg width={width} height={height} viewBox="0 0 37 39" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M34.1614 21.224C33.3366 24.3577 29.439 26.572 21.6433 31.0009C14.1073 35.2821 10.3395 37.4229 7.30294 36.5624C6.04753 36.2066 4.90371 35.5311 3.98123 34.6003C1.75 32.3491 1.75 27.9827 1.75 19.25C1.75 10.5173 1.75 6.1509 3.98123 3.89975C4.90371 2.96905 6.04753 2.29339 7.30294 1.93765C10.3395 1.07718 14.1073 3.21783 21.6433 7.49917C29.439 11.9279 33.3366 14.1423 34.1614 17.276C34.5018 18.5696 34.5018 19.9304 34.1614 21.224Z" stroke={color} stroke-width="3.5" stroke-linejoin="round"/>
</svg>
)

export const MonitorIcon = ({ color = '#8C8C8C', width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="3" y="4" width="18" height="12" rx="2" stroke={color} strokeWidth="2" />
    <path d="M8 20H16" stroke={color} strokeWidth="2" />
  </svg>
);

export const LiveCamIcon = ({ color = '#8C8C8C', width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="1" y="5" width="15" height="14" rx="2" stroke={color} strokeWidth="2" />
    <path d="M23 7L16 12L23 17V7Z" stroke={color} strokeWidth="2" />
  </svg>
);

export const ReportIssueIcon = ({ color = '#8C8C8C', width = 18, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9V14M12 17.01L12.01 16.9984M10.29 3.86L1.82 18C1.64539 18.3024 1.55299 18.6453 1.55201 18.9945C1.55103 19.3437 1.64154 19.6871 1.81448 19.9904C1.98741 20.2937 2.23674 20.5468 2.53754 20.7245C2.83833 20.9022 3.17992 20.9984 3.528 21H20.472C20.8201 20.9984 21.1617 20.9022 21.4625 20.7245C21.7633 20.5468 22.0126 20.2937 22.1855 19.9904C22.3585 19.6871 22.449 19.3437 22.448 18.9945C22.447 18.6453 22.3546 18.3024 22.18 18L13.71 3.86C13.5318 3.55444 13.2774 3.30397 12.9739 3.13511C12.6703 2.96625 12.3283 2.88477 11.985 2.90001C11.6417 2.91526 11.3093 3.02671 11.0232 3.22253C10.7371 3.41834 10.507 3.69176 10.3575 4.01353L10.29 4.14V3.86Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);